import { Select, MenuItem } from "@material-ui/core";
import { Field, ErrorMessage, useFormikContext } from "formik";

import { CaseDataResponse } from "../../../types/CaseTypes";
import { useCaseViewStyle } from "../../../components/CaseView/useCaseViewStyle";
import FMUInputField from "../../../components/shared/FormIkMUFormComponent/FMUInputField";
import { useClientData } from "../../../hooks/CaseView/useClientData";
import { Typography } from "@mui/material";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";

function ClientInformationSection() {
  const classes = useCaseViewStyle();
  const { values, setFieldValue } = useFormikContext<CaseDataResponse>();
  const { clientList, getClientContacts, getContactInfo } = useClientData();
  const supervisorName =
    values.case_detail.case_details.assigment_information.supervisor_name;
  const contacts = getClientContacts(values.case_detail.client_id)?.contacts;

  return (
    <div className={classes.leftBottom}>
      <div className={classes.leftInformationDiv}>
        <div className={classes.cardHead}>
          <span className={classes.cardHeadIcon}>
            <BusinessOutlinedIcon />
          </span>
          <h5 className={classes.tabHeading}>Client Information</h5>
        </div>
        <div className={classes.infoContainer}>
          <div
            className={`${classes.cardContentContainer} ${classes.fieldWide}`}
          >
            <div className={classes.labelContainer}>
              <Typography variant="h6" className={classes.label}>
                Client Name
              </Typography>
            </div>
            <Select
              className={classes.formikInput}
              disableUnderline
              value={values.case_detail.client_id}
              onChange={(e) => {
                setFieldValue(
                  "case_detail.client_id",
                  e.target.value as string,
                  false
                );
                // Representatives belong to a client, so a new client clears the pick.
                setFieldValue(
                  "case_detail.case_details.assigment_information.supervisor_name",
                  "",
                  false
                );
              }}
            >
              {clientList.map((item, index) => (
                <MenuItem key={index} value={item.client_id}>
                  {item.client_name}
                </MenuItem>
              ))}
            </Select>
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant="h6" className={classes.label}>
                Servicer
              </Typography>
            </div>
            <Field
              name="case_detail.case_details.client_information.client_loan"
              type="text"
              className={`${classes.formikInput} ${classes.fieldPaddingRight}`}
              disableUnderline={true}
              component={FMUInputField}
            />
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant="h6" className={classes.label}>
                Client file #
              </Typography>
            </div>
            <Field
              name='case_detail.case_details.client_information["client_file_no"]'
              className={`${classes.formikInput} ${classes.fieldPaddingRight}`}
              disableUnderline={true}
              component={FMUInputField}
            />
          </div>

          <ErrorMessage name='case_detail.case_details.client_information["client_file_no"]'>
            {(msg) => (
              <div className={classes.formikInputValidation}>{msg}</div>
            )}
          </ErrorMessage>

          <div
            className={`${classes.cardContentContainer} ${classes.fieldWide}`}
          >
            <div className={classes.labelContainer}>
              <Typography variant="h6" className={classes.label}>
                Client representative
              </Typography>
            </div>
            <Select
              className={classes.formikInput}
              style={{ zIndex: "1000" }}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
              disableUnderline
              value={supervisorName}
              onChange={(e) => {
                setFieldValue(
                  "case_detail.case_details.assigment_information.supervisor_name",
                  e.target.value,
                  false
                );
              }}
            >
              <MenuItem value="">None</MenuItem>
              {contacts?.map((item, index) => (
                <MenuItem key={index} value={item.id} button>
                  {`${item.first_name} ${item.last_name}`.trim()}
                </MenuItem>
              ))}
            </Select>
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant="h6" className={classes.label}>
                Email
              </Typography>
            </div>
            <span
              className={`${classes.formikView} ${classes.fieldPaddingRight}`}
            >
              {getContactInfo(
                values.case_detail.client_id,
                values.case_detail.case_details.assigment_information
                  .supervisor_name,
                "email"
              )}
            </span>
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant="h6" className={classes.label}>
                Phone #
              </Typography>
            </div>
            <span
              className={`${classes.formikView} ${classes.fieldPaddingRight}`}
            >
              {getContactInfo(
                values.case_detail.client_id,
                values.case_detail.case_details.assigment_information
                  .supervisor_name,
                "phone"
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientInformationSection;
